'use client';

import type TrailPageType from '@alltrails/amplitude/enums/TrailPageType';
import ReviewSummaryPackage from '@alltrails/reviews/components/ReviewSummary/ReviewSummary';
import type { Review } from '@alltrails/types/Review';
import type { TrailId } from '@alltrails/types/TrailId';
import { useReviewSummaryContext } from '@/contexts/ReviewSummaryContext';
import { REVIEWS_SECTION_ID } from '@/utils/constants';
import styles from './ReviewSummary.module.scss';

type ReviewSummaryProps = {
  trailId: TrailId;
  shuffledReviews?: Review[];
  isAdmin?: boolean;
  shouldExpand?: boolean;
  isInline?: boolean;
  isAboveSearchPosition?: boolean;
  avgRating?: number;
  trailPageType: TrailPageType;
  seoTestLongSummary?: boolean;
  hideShowAllReviewsButton?: boolean;
};

const onShowAllReviewsClick = () => {
  const reviewSection = document.getElementById(REVIEWS_SECTION_ID);
  if (reviewSection) {
    reviewSection.focus();
    reviewSection.scrollIntoView({ behavior: 'smooth' });
  }
};

const ReviewSummary = ({ isAboveSearchPosition, ...props }: ReviewSummaryProps) => {
  const { isLoading, hideReviewSummary, reviewSummary, onToggleHideReviewSummary } = useReviewSummaryContext();

  const summary = (
    <ReviewSummaryPackage
      {...props}
      reviewSummary={reviewSummary}
      hideReviewSummary={hideReviewSummary}
      isLoading={isLoading}
      onToggleHideReviewSummary={onToggleHideReviewSummary}
      inlineDividerPosition={isAboveSearchPosition ? 'none' : 'top'}
      onShowAllReviewsClick={isAboveSearchPosition ? undefined : onShowAllReviewsClick}
    />
  );

  if (isAboveSearchPosition) {
    return <div className={styles.aboveSearchPosition}>{summary}</div>;
  }
  return summary;
};

export default ReviewSummary;
